import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import TrackOrder from "./pages/TrackOrder";
import ShareStory from "./pages/ShareStory";
import FindYourBlend from "./pages/FindYourBlend";
import Founders from "./pages/Founders";
import AuthCallback from "./pages/AuthCallback";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import { CartProvider } from "./lib/CartContext";
import CartDrawer from "./components/CartDrawer";

function AppRouter() {
  const location = useLocation();

  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/track-order" element={<TrackOrder />} />
      <Route path="/share-your-story" element={<ShareStory />} />
      <Route path="/find-your-blend" element={<FindYourBlend />} />
      <Route path="/founder" element={<Founders />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <CartDrawer />
        <AppRouter />
        <Toaster position="top-right" />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
